import React from 'react';
import { useLoginContext } from '../../../Contexts/LoginContext';
import { formatCpf, formatPhone } from '../../../Utils/Formatters';
import ButtonLink from '../../Form/ButtonLink';
import { useNavigate } from 'react-router-dom';
import ProfileTitle from '../../../Pages/Profile/ProfileTitle';
import ConfirmMobilePhone from './ConfirmMobilePhone';
import CardProfileBasicInfoItem from './CardProfileBasicInfoItem';
import { useTranslation } from 'react-i18next';
import { MdVerified } from 'react-icons/md';

const CardProfileBasicInfo = () => {

    const { t } = useTranslation();
    const { user } = useLoginContext();
    const navigate  = useNavigate();

    return (
        <div className='flex flex-col gap-4 w-full h-full justify-between'>
            <ProfileTitle className='h-auto'>{t('profile.basic_info.title')}</ProfileTitle>

            <div className='flex flex-col gap-3 h-full'>
                <CardProfileBasicInfoItem title={t('profile.basic_info.name')} value={ user.first_name.trim() ? user.first_name : '-' } />
                <CardProfileBasicInfoItem title={t('profile.basic_info.last_name')} value={ user.last_name.trim() ? user.last_name : '-' } />

                <div className='grid'>
                    <span className="text-gray-400 leading-none">{t('profile.basic_info.email.label')}</span>
                    <span className="font-semibold flex items-center gap-2">
                        { user.email ? user.email : '-' }
                        {(user.is_confirmed || user.email) &&
                            <div className="flex items-center">
                                <MdVerified className='text-shopfood-success text-sm' />
                                <span className='text-xs leading-none text-nowrap text-gray-400 mr-1 italic font-medium'>{t('profile.basic_info.email.verified_label')}</span>
                            </div>
                        }
                    </span>
                </div>

                <CardProfileBasicInfoItem title={t('profile.basic_info.document_cpf')} value={ user.cpf ? formatCpf(user.cpf) : '-' } />

                <div className='grid'>
                    <span className="text-gray-400 leading-none">{t('profile.basic_info.mobile_phone.label')}</span>
                    <span className="font-semibold flex items-center gap-2">
                        { user.mobile_phone ? formatPhone(user.mobile_phone) : '-' }
                        <ConfirmMobilePhone phone={user.mobile_phone} confirmed={user.mobile_phone_confirmed} onSuccess={() => {}} />
                    </span>
                </div>

                <CardProfileBasicInfoItem title={t('profile.basic_info.birthdate')} value={ user.birthdate ? user.birthdate : '-' } />
                <CardProfileBasicInfoItem title={t('profile.basic_info.gender')} value={ user.gender ? t(`profile.gender.${user.gender}`) : '-' } />
                <CardProfileBasicInfoItem title={t('profile.basic_info.on_fidelity_program')} value={ user.on_fidelity_program ? t('layout.label_yes') : t('layout.label_no') } />

            </div>

            <ButtonLink onClick={() => navigate('/perfil/dados-cadastrais')} className='w-full md:w-max'>{t('profile.basic_info.button_edit_label')}</ButtonLink>
        </div>
    )
}

export default CardProfileBasicInfo;